import { render } from "./AccountsTable.vue?vue&type=template&id=2c67803d&scoped=true"
import script from "./AccountsTable.vue?vue&type=script&lang=js"
export * from "./AccountsTable.vue?vue&type=script&lang=js"

import "./AccountsTable.vue?vue&type=style&index=0&id=2c67803d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c67803d"]])

export default __exports__